import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'

export const useGetAvailabilitiesApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({productId, optionId, localDateStart, localDateEnd, units, currency}: Params.GetAvailabilities) => {
      const {data} = await ventrata.post<Ventrata.Availability[]>(
        '/availability',
        {
          productId,
          optionId,
          units,
          localDateStart,
          localDateEnd,
          currency,
        },
        {
          headers: {
            'Octo-Capabilities': 'octo/pricing',
          },
        }
      )

      return data
    },
    [ventrata]
  )
}
